import { connect } from 'react-redux';
import { branch, compose, lifecycle } from 'recompose';
import { getMarketingListsByAccountType } from '../../../helpers/account';
import { getUserMarketingPreferences } from '../../../store/reducers/account/actions';
import { getMarketingLists } from '../../../store/reducers/marketing-lists';
import { withLoader } from '../../../components/template';
import { ConfigService } from '../../../services/config-service';

const mapDispatchToProps = state => {
  const account = state.account;

  return {
    lists: getMarketingListsByAccountType(state.marketingLists.lists),
    subscribtions: state.account.marketingListIds,
    loading: state.account.loadingMarketingListIds || state.marketingLists.loading,
    error: account.marketingListIdsError
  };
};

// this part can be moved to a separate account Route group
// with current react-router version it was hard to achieve the needed result
// so can be updated within ticket LM-621

const fetchMarketingLists = compose(
  lifecycle({
    async componentDidMount() {
      const { lists, subscribtions, getMarketingLists, getUserMarketingPreferences } = this.props;

      if (!lists.length) {
        await getMarketingLists();
      }

      if (!subscribtions.length) {
        await getUserMarketingPreferences();
      }
    }
  }),
  withLoader
);

export const withMarketingListData = compose(
  connect(mapDispatchToProps, { getMarketingLists, getUserMarketingPreferences }),
  branch(() => ConfigService.get('DISPLAY_MODULES.MARKETING', false), fetchMarketingLists)
);
